export function linkify(text) {
    if (!text) {
        return text;
    }

    const urlRegex = /(https:\/\/[^\s]+[^\s.,!?;:'")\]}])/g;

    return text.split(urlRegex).map((part, index) => {
        if (part.match(urlRegex)) {
            return (
                <a key={index} href={part} target="_blank" rel="noopener noreferrer"
                   className="underline hover:no-underline break-all">
                    {part}
                </a>
            );
        }

        return part;
    });
}
